import SVGIcon from "ui/icons/SVGIcon";

interface IconRoleProps {
  userRole?: "sales_manager" | "field_staff" | "sales_agent" | "admin" | "super_admin"; // Matches CSS class names
  size?: number;
}

export default function IconRole({ size = 12, userRole = "super_admin" }: IconRoleProps) {
  switch (userRole) {
    case "admin": {
      return (
        <SVGIcon width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" size={size}>
          <path
            d="M15 33H4.5C3.67157 33 3 33.6716 3 34.5V57H13.5C14.3284 57 15 56.3284 15 55.5V33Z"
            stroke="currentColor"
            strokeWidth="6"
          />
          <path
            d="M14.3608 26.9859C14.1571 13.4771 25.4902 3 39.0006 3V3C52.511 3 63.8442 13.4771 63.6405 26.9859C63.5772 31.182 63.3903 35.3632 63.0006 39C62.4835 43.8264 60.9011 49.6829 59.2043 54.9358C56.4081 63.5923 48.0976 69 39.0006 69V69C29.9038 69 21.5934 63.5924 18.7971 54.936C17.1003 49.683 15.5177 43.8265 15.0006 39C14.611 35.3632 14.4241 31.182 14.3608 26.9859Z"
            stroke="currentColor"
            strokeWidth="6"
          />
          <path d="M15 33C24 33 39 30 48 18" stroke="currentColor" strokeWidth="6" />
          <path
            d="M39.0583 36.5883L42.0439 51.5166L47.9274 50.3399L44.9417 35.4117L39.0583 36.5883ZM44.9268 48H36V54H44.9268V48ZM42.0439 51.5166C41.6801 49.6973 43.0715 48 44.9268 48V54C46.8578 54 48.3061 52.2334 47.9274 50.3399L42.0439 51.5166Z"
            fill="currentColor"
          />
        </SVGIcon>
      );
    }
    case "sales_manager": {
      return (
        <SVGIcon width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" size={size}>
          <path
            d="M63.0004 20.9996L60.0004 20.9996L63.0004 20.9996ZM63.0006 27L60.0006 27.0001L60.0007 29.9997L63.0003 30L63.0006 27ZM61.2255 44.9173L60.8208 41.9447L58.9071 42.2052L58.3521 44.0551L61.2255 44.9173ZM57.8486 56.1727L54.9751 55.3106L57.8486 56.1727ZM21.7125 60.54L19.1685 62.13L21.7125 60.54ZM12 45L14.544 43.41L13.6627 42H12V45ZM9.11321 27V30H12.3727L12.1029 26.7517L9.11321 27ZM27 0C15.402 0 6 9.40202 6 21H12C12 12.7157 18.7157 6 27 6V0ZM45.0004 0H27V6H45.0004V0ZM66.0004 20.9995C66.0002 9.40171 56.5982 0 45.0004 0V6C53.2846 6 60.0002 12.7155 60.0004 20.9996L66.0004 20.9995ZM66.0006 26.9999L66.0004 20.9995L60.0004 20.9996L60.0006 27.0001L66.0006 26.9999ZM72 33C72 28.0297 67.971 24.0005 63.0009 24L63.0003 30C64.657 30.0002 66 31.3432 66 33H72ZM72 36V33H66V36H72ZM61.6303 47.8898C67.4876 47.0923 72 42.0756 72 36H66C66 39.0341 63.7451 41.5465 60.8208 41.9447L61.6303 47.8898ZM60.722 57.0348L64.099 45.7794L58.3521 44.0551L54.9751 55.3106L60.722 57.0348ZM40.6078 72C49.8814 72 58.057 65.9172 60.722 57.0348L54.9751 55.3106C53.0715 61.6552 47.2318 66 40.6078 66V72ZM36.9765 72H40.6078V66H36.9765V72ZM19.1685 62.13C23.006 68.27 29.7359 72 36.9765 72V66C31.8046 66 26.9976 63.3357 24.2565 58.95L19.1685 62.13ZM9.45601 46.59L19.1685 62.13L24.2565 58.95L14.544 43.41L9.45601 46.59ZM0 36C0 42.6274 5.37258 48 12 48V42C8.68629 42 6 39.3137 6 36H0ZM0 33V36H6V33H0ZM9 24C4.02944 24 0 28.0294 0 33H6C6 31.3431 7.34315 30 9 30V24ZM9.11321 24H9V30H9.11321V24ZM6 24.2688C6 25.2637 6.04124 26.2577 6.12351 27.2483L12.1029 26.7517C12.0344 25.9262 12 25.0979 12 24.2688H6ZM6 21V24.2688H12V21H6Z"
            fill="currentColor"
          />
          <path
            d="M42 30C42 34.0353 43.0494 37.5182 44.3009 40.2376L49.7514 37.7293C48.776 35.6098 48 32.985 48 30H42ZM43.7574 42H36V48H43.7574V42ZM44.3009 40.2376C44.3413 40.3255 44.3863 40.4937 44.3693 40.748C44.3522 41.0032 44.2758 41.2782 44.1499 41.5209C43.8625 42.075 43.6292 42 43.7574 42V48C46.5583 48 48.518 46.1307 49.4761 44.2836C50.4329 42.4388 50.7737 39.9509 49.7514 37.7293L44.3009 40.2376Z"
            fill="currentColor"
          />
          <path
            d="M9 27H6V30H9V27ZM25.5 15V12H23.421L22.691 13.9466L25.5 15ZM21.146 26.6107L23.955 27.6641L23.955 27.664L21.146 26.6107ZM9 30H18V24H9V30ZM6 21V27H12V21H6ZM27 0C15.402 0 6 9.40202 6 21H12C12 12.7157 18.7157 6 27 6V0ZM30 0H27V6H30V0ZM45 0H30V6H45V0ZM66 21C66 9.40202 56.598 0 45 0V6C53.2843 6 60 12.7157 60 21H66ZM66 27V21H60V27H66ZM51 18C55.9706 18 60 22.0294 60 27H66C66 18.7157 59.2843 12 51 12V18ZM25.5 18H51V12H25.5V18ZM23.955 27.664L28.309 16.0534L22.691 13.9466L18.337 25.5573L23.955 27.664ZM20.5842 30C22.0848 30 23.4281 29.0691 23.955 27.6641L18.337 25.5573C18.6883 24.6206 19.5838 24 20.5842 24V30ZM18 30H20.5842V24H18V30Z"
            fill="currentColor"
          />
        </SVGIcon>
      );
    }
    case "field_staff": {
      return (
        <SVGIcon width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" size={size}>
          <path
            d="M11.8635 30.817L10.7463 37.5203C10.1119 41.3267 11.9543 44.8962 14.9997 46.725V49.7906C14.9997 52.5154 15.927 55.1591 17.6292 57.2869L25.1982 66.7481C26.3368 68.1714 28.0607 68.9999 29.8834 68.9999H42.1159C43.9386 68.9999 45.6625 68.1714 46.8011 66.7481L54.3701 57.2869C56.0723 55.1591 56.9997 52.5154 56.9997 49.7906V46.725C60.045 44.8962 61.8875 41.3267 61.2531 37.5203L60.1358 30.817"
            stroke="currentColor"
            strokeWidth="6"
          />
          <path
            d="M33.0144 50.9282L30.0726 50.3399L33.0144 50.9282ZM33.0583 35.4117L30.0726 50.3399L35.9561 51.5166L38.9417 36.5883L33.0583 35.4117ZM33.0732 54H42V48H33.0732V54ZM30.0726 50.3399C29.6939 52.2334 31.1422 54 33.0732 54V48C34.9285 48 36.3199 49.6973 35.9561 51.5166L30.0726 50.3399Z"
            fill="currentColor"
          />
          <path
            d="M44.6301 4.84957C51.052 7.74812 55.7549 13.782 56.7873 21H57C60.3137 21 63 23.6863 63 27V30C41.9113 36.1933 30.0887 36.2 9 30V27C9 23.6863 11.6863 21 15 21H15.2127C16.2451 13.782 20.948 7.74812 27.3699 4.84957M44.6301 4.84957L45 3H27L27.3699 4.84957M44.6301 4.84957L42 18M27.3699 4.84957L30 18"
            stroke="currentColor"
            strokeWidth="6"
          />
        </SVGIcon>
      );
    }
    case "sales_agent": {
      return (
        <SVGIcon width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" size={size}>
          <path
            d="M13.875 33.375L12.75 36.75L10.5 43.5L6.16298 56.5111C6.07378 56.7787 6.22347 57.067 6.49365 57.1481L21 61.5M51 61.5L65.5064 57.1481C65.7765 57.067 65.9262 56.7787 65.837 56.5111L61.5 43.5L60 39"
            stroke="currentColor"
            strokeWidth="6"
          />
          <path
            d="M14.6968 33C14.7268 33.7892 14.7979 34.5837 14.9119 35.3812L15.0003 36L18.317 54.242C19.8708 62.7881 27.3141 69 36.0003 69C44.6864 69 52.1297 62.7881 53.6835 54.242L55.0405 46.7785C56.8897 45.7017 58.3419 43.9745 59.0514 41.846L60.3676 37.8974C61.3657 34.9032 59.6097 31.8337 57 30.5832V27"
            stroke="currentColor"
            strokeWidth="6"
          />
          <path
            d="M33.0144 50.9282L30.0726 50.3399L33.0144 50.9282ZM33.0583 35.4117L30.0726 50.3399L35.9561 51.5166L38.9417 36.5883L33.0583 35.4117ZM33.0732 54H42V48H33.0732V54ZM30.0726 50.3399C29.6939 52.2334 31.1422 54 33.0732 54V48C34.9285 48 36.3199 49.6973 35.9561 51.5166L30.0726 50.3399Z"
            fill="currentColor"
          />
          <path
            d="M42 21C36 27 21 33 9 33L17.2273 2.83336C17.6567 1.25888 19.2659 0.316476 20.8492 0.712291L41.8432 5.96079C41.9451 5.98628 42.0525 5.97899 42.1501 5.93995L54.2572 1.09711C55.5709 0.571622 57 1.53914 57 2.95407V30C48 30 43.6423 23.2963 42 21Z"
            stroke="currentColor"
            strokeWidth="6"
          />
        </SVGIcon>
      );
    }
    default: {
      return (
        <SVGIcon width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" size={size}>
          <path
            d="M36 57C36 57 48 57 52.5 57C62.9296 57 69 48 69 36C69 25.731 66.1305 17.614 60.7424 12"
            stroke="currentColor"
            strokeWidth="6"
          />
          <path
            d="M10.74 33H9C6 33 3 36 3 39V51C3.0002 54 5.99995 57 9 57H15L15 48"
            stroke="currentColor"
            strokeWidth="6"
          />
          <path d="M9 27V6" stroke="currentColor" strokeWidth="6" />
          <path
            d="M36 3C25.6114 3 17.4712 7.49679 15.4723 16.4904M15 37.2V51C15 63 27 69 36 69C45 69 57 63 57 51V37.2"
            stroke="currentColor"
            strokeWidth="6"
          />
          <path
            d="M33.0144 44.9282L30.0726 44.3399L33.0144 44.9282ZM33.0732 48H42V42H33.0732V48ZM31.5583 36.9117L30.0726 44.3399L35.9561 45.5166L37.4417 38.0883L31.5583 36.9117ZM32.3083 33.1617L31.5583 36.9117L37.4417 38.0883L38.1917 34.3383L32.3083 33.1617ZM32.6833 31.2867L32.3083 33.1617L38.1917 34.3383L38.5667 32.4633L32.6833 31.2867ZM33.0732 42C34.9285 42 36.3199 43.6973 35.9561 45.5166L30.0726 44.3399C29.6939 46.2334 31.1422 48 33.0732 48V42Z"
            fill="currentColor"
          />
          <path
            d="M21 15H51C57 15 63 20.3726 63 27C63 33.6274 57 39 51 39H45.8284C45.298 39 44.7893 38.7893 44.4142 38.4142L36.7071 30.7071C36.3166 30.3166 35.6834 30.3166 35.2929 30.7071L27.5858 38.4142C27.2107 38.7893 26.702 39 26.1716 39H21C15 39 9 33.6274 9 27C9 20.3726 15 14.9999 21 15Z"
            stroke="currentColor"
            strokeWidth="6"
          />
          <path d="M36 3H63V13.5C63 14.3284 62.3284 15 61.5 15H36" stroke="currentColor" strokeWidth="6" />
        </SVGIcon>
      );
    }
  }
}
